import { useNavigate } from "react-router-dom";
import TableFilter from "./tableFilter";

function MembershipTypePaymentDetails() {
  // const navigate = useNavigate();
  return (
    <>
      <div className="content-wrapper">
        <div
          className="content-heading d-flex
                          justify-content-between"
        >
          <div>Membership type and Payment Details(UPI ID)</div>
          <div>
           
          </div>
        </div>
        <TableFilter />
      </div>
    </>
  );
}

export default MembershipTypePaymentDetails;
